export default import.meta.ROLLUP_FILE_URL_b6_b8IsyONwvuMKbSet7KQ;